import { render, staticRenderFns } from "./DoughnutChart.vue?vue&type=template&id=09fd3744&scoped=true&"
import script from "./DoughnutChart.vue?vue&type=script&lang=ts&"
export * from "./DoughnutChart.vue?vue&type=script&lang=ts&"
import style0 from "./DoughnutChart.vue?vue&type=style&index=0&id=09fd3744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd3744",
  null
  
)

export default component.exports